import { render, staticRenderFns } from "./RegistroFotograficoModal.vue?vue&type=template&id=a5ee53ba&scoped=true"
import script from "./RegistroFotograficoModal.vue?vue&type=script&lang=js"
export * from "./RegistroFotograficoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ee53ba",
  null
  
)

export default component.exports